export enum PriceMetadataSource {
  OptionPrice = 'Option Price property',
  OptionConditionPrice = 'Option Condition w/ price',
  PriceCondition = 'Price Condition',
  MultiLengthCombo = 'Multi-length Combo',
  ComponentPackage = 'Component Package',
  StandardFeatures = 'Standard Features',
}
